import { queryClient } from '@/lib/queryClient'
import { flattenPages } from '@/utils/flattenPages'

import { QueryKeys } from '@/enums'

import { getReactionActivityId } from '../../getReactionActivityId'

export const getTrendingFeedActivityIds = () => {
  return flattenPages(
    queryClient.getQueryData([QueryKeys.TrendingFeed]),
    'data'
  ).map(getReactionActivityId)
}
